import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import { IAccordionItemYeah } from '../yeah.state'
import AccordionItem from '../accordion-item/accordion-item'

interface IAccordionSectionProps {
    title: string;
    accordionItems: Array<IAccordionItemYeah>;
}

const AccordionSectionYeah = ({ title, accordionItems }: IAccordionSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_px80}`}>
            <div className={`${style.container}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${style.title_middle} ${style.mb40} ${style.text_align_l} ${animations.scroll__animation}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${style.accordion}`}>
                    {
                        accordionItems.map((item: IAccordionItemYeah, index: number) => {
                            return (
                                <AccordionItem key={index} id={item.id} title={item.name} text={item.text} />
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default AccordionSectionYeah;
